import { useParams } from "react-router";
import { useHtzWorkOrderShowQuery } from "@/services/backend/htz/work-order/api/work-order-api";
import { NullUUID } from "@bitory-gmbh/nidavellir";
import { useCommitment } from "@/services/backend/relationships/hooks/use-commitment";
import { WorkOrderData } from "../../../work-orders/[workOrderId]/data/_components/work-order-data";

export function WorkOrderRoute() {
  const { relationshipId, commitmentId } = useParams();
  const { data: commitment } = useCommitment(relationshipId!, commitmentId!);

  const { data } = useHtzWorkOrderShowQuery({
    id: commitment?.documentId || NullUUID,
  });

  if (!data) return null;

  return <WorkOrderData workOrder={data} />;
}
